export * from './dateFormats';
export * from './entityTypes';
export * from './files';
export * from './routes';
export * from './theme';
export * from './workspaces';
export * from './regexUtils';
export * from './kineticModules';
export * from './staticEventFields';
export * from './communicationParameters';
export * from './treeMenu';
export * from './MapColors';
export * from './system';
export * from './timezone';
export * from './timeZoneOptions';
export * from './serviceAccountUser';
export * from './recoilKeys';
export * from './queryParams';

export const DRAWER_WIDTH = 285;
export const TABLE_DRAWER_WIDTH = 350;

export const UNGROUPED = '__UNGROUPED__';

export const FILE_EXTENSION = {
  'image/png': ['.png'],
  'image/jpg': ['.jpg'],
  'image/jpeg': ['.jpeg'],
};
export const IMAGE_SIZE = 5242880;

export const CAMERA_PLAYER_PAGE_WIDTH = 1000;
export const CAMERA_PLAYER_PAGE_HEIGHT = 600;
